<script setup>
import { nextTick, onMounted, onUnmounted, ref } from 'vue'
import AppIcon from './AppIcon.vue'

const props = defineProps({ title: { type: String, required: true }, description: { type: String, default: '' }, wide: Boolean, dirty: Boolean })
const emit = defineEmits(['close'])
const dialog = ref(null)

const requestClose = () => {
  if (props.dirty && !confirm('尚有未保存的修改，确定关闭吗？')) return
  dialog.value?.close()
  emit('close')
}

const handleCancel = (event) => { event.preventDefault(); requestClose() }

onMounted(async () => { await nextTick(); dialog.value?.showModal() })
onUnmounted(() => { if (dialog.value?.open) dialog.value.close() })
</script>

<template>
  <dialog ref="dialog" class="modal" :class="{ 'modal-wide': wide }" :aria-label="title" @cancel="handleCancel">
    <div class="modal-shell">
      <header class="modal-header">
        <div><h2>{{ title }}</h2><p v-if="description">{{ description }}</p></div>
        <button class="icon-button" type="button" aria-label="关闭" title="关闭" @click="requestClose"><AppIcon name="close" tone="neutral" /></button>
      </header>
      <div class="modal-body"><slot /></div>
      <footer v-if="$slots.footer" class="modal-footer"><slot name="footer" /></footer>
    </div>
  </dialog>
</template>

<style scoped>
.modal{border:0;padding:0;background:transparent;width:min(620px,calc(100vw - 32px));max-height:calc(100dvh - 32px);overflow:visible}.modal-wide{width:min(980px,calc(100vw - 32px))}.modal::backdrop{background:rgba(15,23,42,.5);backdrop-filter:blur(5px)}.modal-shell{display:flex;max-height:calc(100dvh - 32px);flex-direction:column;overflow:hidden;border:1px solid rgba(255,255,255,.8);border-radius:24px;background:#fff;box-shadow:0 28px 80px rgba(15,23,42,.22)}.modal-header{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:22px 24px;border-bottom:1px solid var(--border)}.modal-header h2{margin:0;font-size:22px}.modal-header p{margin:5px 0 0;color:var(--muted);font-size:13px}.modal-body{overflow:auto;padding:24px}.modal-footer{display:flex;justify-content:flex-end;gap:10px;padding:16px 24px;border-top:1px solid var(--border);background:#f8fafc}@media(max-width:640px){.modal,.modal-wide{width:100vw;max-width:none;height:100dvh;max-height:none;margin:0}.modal-shell{height:100dvh;max-height:none;border-radius:0;border:0}.modal-header{padding:18px 16px}.modal-body{padding:18px 16px}.modal-footer{padding:12px 16px max(12px,env(safe-area-inset-bottom))}}
</style>
